/**
 * Field component themable props.
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray(["default", "success", "danger"])
}
